// For options visit https://github.com/biati-digital/glightbox
import GLightbox from 'glightbox'

export const initLightbox = (): void => {
    GLightbox({
        touchNavigation: true,
        autoplayVideos: true,
        selector: '.glightbox',
    })
}
